<template>
    <v-container class="pt-4 pb-12 py-sm-12">
       <v-row>
    <v-col :cols="12">
        <div class="title-container">
            <div class="title-block">
                <span id="title" class="page-title">Cupons</span>
                <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                    { text: 'Homepage', disabled: false, to: '/home', exact: true },
                    { text: 'Cupons', disabled: true, exact: true },
                ]"></v-breadcrumbs>
            </div>
            <div class="button-group">
                <v-btn type="button" elevation="0" color="primary" dark to="/cupons/novo" :loading="dataset.loading">
                    <v-icon class="mr-2" size="large">mdi-plus</v-icon>
                    Adicionar
                </v-btn>
                <v-btn type="button" elevation="0" color="primary" outlined dark @click="loadData" :loading="dataset.loading">
                    <v-icon class="mr-2" size="large">mdi-refresh</v-icon>
                    Atualizar
                </v-btn>
            </div>
        </div>
    </v-col>
</v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table
  :headers="visibleHeaders"
  :items="dataList.data"
  :server-items-length="dataList.count"
  :disable-sort="true"
  :loading="dataList.loading"
  no-data-text="Nenhum cupom foi encontrado"
  loading-text="Carregando dados..."
  class="app-table hover-table coupon-table"
  :options.sync="dataList.options"
:footer-props="dataList.footerOptions"
>

                    <template v-slot:[`item.coupon`]="{ item }">
                        {{ item.codigo }}
                    </template>

                    <template v-slot:[`item.startDate`]="{ item }">
                        {{ item.dataInicio | defaultDate }}
                    </template>

                    <template v-slot:[`item.endDate`]="{ item }">
                        {{ item.dataFim | defaultDate }}
                    </template>

                    <template v-slot:[`item.startTime`]="{ item }">
                        {{ item.horaInicio }}
                    </template>

                    <template v-slot:[`item.endTime`]="{ item }">
                        {{ item.horaFim }}
                    </template>

                    <template v-slot:[`item.limit`]="{ item }">
                        {{ item.limiteUtilizacao }}
                    </template>

                    <template v-slot:[`item.used`]="{ item }">
                        {{ item.qtdUtilizacaoCupom }}
                    </template>

                    <template v-slot:[`item.type`]="{ item }">
                        {{ item.tipoDesconto.substring(0, 5) }}
                    </template>

                    <template v-slot:[`item.value`]="{ item }">
    <span style="white-space: nowrap;">
        {{ item.tipoDesconto === "PORCENTAGEM" ? '%' : 'R$' }} {{ item.valorDesconto | currency }}
    </span>
</template>

                    <template v-slot:[`item.daysOfWeek`]="{ item }">
                        {{Array.isArray(item.diaDaSemana) && item.diaDaSemana.length
                            ? item.diaDaSemana.map((x) => x.substring(0, 3)).join(", ")
                            : "-"}}
                    </template>

                           <template v-slot:[`item.active`]="{ item }">
    <span :class="item.ativo ? 'green--text' : ''" :style="!item.ativo ? 'color: #FF3636 !important;' : ''">
        <strong>{{ item.ativo ? "Ativo" : "Inativo" }}</strong>
    </span>
</template>

                    <template v-slot:[`item.actions`]="{ item }">
    <div class="d-flex align-center actions-row">
                            <!-- <v-icon @click="viewItem(item)" size="large">
                                mdi-pencil-outline
                            </v-icon> -->
                          <v-btn :disabled="dataList.loading" color="primary-200" @click="viewItem(item)" small class="action-btn-fixed">
            <v-icon left>mdi-pencil-outline</v-icon>
            Editar
        </v-btn>
    </div>
</template>
                </v-data-table>
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

import { eventHub } from "@/main"

Vue.use(VueLodash)

export default {
    name: "CouponList",

    data: () => ({
        dataset: {
            data: {},
            operation: null
        },
        dataList: {
            filter: {
                name: "",
            },
headers: [
    { text: "Código", value: "coupon", width: '80px' },
    { text: "Data início", value: "startDate", width: '80px' },
    { text: "Data término", value: "endDate", width: '85px' },
    { text: "Hora início", value: "startTime", width: '80px', hideOnMedium: true },
    { text: "Hora término", value: "endTime", width: '85px', hideOnMedium: true },
    { text: "Dias da semana", value: "daysOfWeek", width: '85px' },
    { text: "Limite", value: "limit", width: '70px' },
    { text: "Utilizações", value: "used", width: '95px', hideOnMedium: true },
    { text: "Tipo", value: "type", width: '70px' },
    { text: "Valor", value: "value", width: '80px' },
    { text: "Ativo", value: "active", width: '70px' },
    { text: "Ações", value: "actions", sortable: false, width: '120px' },
],
            data: [],
            loading: false,
            count: 0,
            options: {
  page: 1,
  itemsPerPage: 10,
},

footerOptions: {
  itemsPerPageText: 'Itens por página:',
  itemsPerPageOptions: [10, 20],
  pageText: '{0}-{1} de {2}',
},
        },
    }),

    computed: {
        // Hora início/término e Utilizações somem em telas menores (ex: notebooks
        // 1024x768) pra tabela não precisar de scroll horizontal.
        visibleHeaders() {
            const isMediumOrSmaller = this.$vuetify.breakpoint.width < 1264;
            return this.dataList.headers.filter((h) => !(isMediumOrSmaller && h.hideOnMedium));
        },
    },

    mounted() {
        eventHub.$on('CHANGE-OPERATION', (value) => {
            this.getSelectedOperation();
            this.loadData()
        })

        this.getSelectedOperation();

        if (!this.dataset.operation) {
            this.$dialog.notify.error('Nenhuma operação selecionada!', { position: 'top-right', timeout: 5000 });
            return;
        }

        this.loadData();
    },

    destroyed() {
        eventHub.$off('CHANGE-OPERATION')
    },

    methods: {

        getColorByUpboxStatus(status) {
            if (!status) return 'mediumGray';

            switch (status.toLowerCase()) {
                case 'livre':
                    return 'green'
                case 'offline':
                    return 'error'
                case 'ocupada':
                    return 'amber'
                default:
                    return 'error'
            }
        },

        getSelectedOperation() {
            this.dataset.operation = localStorage.getItem('operation');
        },

        loadData() {
            this.load()
        },

async load() {
  this.dataList.loading = true;

  try {
    const result = await axios.get('/api/cupom', {
      params: {
        operacaoId: this.dataset.operation,
        page: this.dataList.options.page - 1, // backend começa do 0
        size: this.dataList.options.itemsPerPage
      }
    });

   this.dataList.data = result.data.content;
this.dataList.count = result.data.page ? result.data.page.totalElements : (result.data.totalElements || 0);

  } catch (error) {
    this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
  } finally {
    this.dataList.loading = false;
  }
},

       viewItem(item) {
    this.$router.push(`/cupons/${item.id}`);
},

    },
    watch: {
    'dataList.options': {
        handler: _.debounce(function() {
            this.load();
        }, 300),
        deep: true,
        immediate: true,
        flush: 'post'
    }
}
};

</script>
<style>
.v-card { border-radius: 12px; }
.title-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.title-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

@media (max-width: 600px) {
    .title-container {
        flex-direction: column;
        align-items: flex-start;
    }

    .button-group {
        width: 100%;
    }

    .button-group .v-btn {
        flex: 1;
    }
}
.page-title { font-size: 24px; font-weight: 700; }
.green--text { color: #28a745 !important; }

@media (max-width: 600px) {
    .v-data-footer {
        flex-wrap: wrap !important;
        justify-content: center !important;
        padding: 4px 0 !important;
    }
    .v-data-footer__select {
        order: 1 !important;
        justify-content: center !important;
        margin: 0 !important;
    }
    .v-data-footer__pagination {
        order: 2 !important;
        margin: 0 4px !important;
    }
    .v-data-footer__icons-before {
        order: 3 !important;
        flex: 1 !important;
        justify-content: flex-end !important;
        padding-right: 8px !important;
        margin-top: 4px !important;
    }
    .v-data-footer__icons-after {
        order: 4 !important;
        flex: 1 !important;
        justify-content: flex-start !important;
        padding-left: 8px !important;
        margin-top: 4px !important;
    }
}
.actions-row {
  gap: 4px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.action-btn-fixed {
  width: 100px;
}

.app-table.coupon-table th {
  white-space: normal !important;
}

/* Selector com .coupon-table pra não vazar pra tabelas de outras telas
   (esse <style> não é scoped — sem essa classe, valia globalmente). */
@media (max-width: 768px) {
.app-table.coupon-table.v-data-table--mobile .v-data-table__mobile-row {
  padding: 4px 0 !important;
  min-height: auto !important;
}
  .app-table.coupon-table.v-data-table--mobile tbody tr {
    border-bottom: 2px solid #000 !important;
    margin-bottom: 8px !important;
    padding-bottom: 4px !important;
    display: block !important;
  }

  .app-table.coupon-table.v-data-table--mobile .v-data-table__mobile-row {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
  }

  .app-table.coupon-table.v-data-table--mobile .v-data-table__mobile-row__cell {
    text-align: right !important;
  }
}


</style>